<template>
  <div class="min-h-screen w-full bg-gradient-to-br from-gray-50 via-red-50 to-orange-50 fixed inset-0 overflow-y-auto pt-16">
    <!-- Header moderne -->
    <div class="relative overflow-hidden bg-white/80 backdrop-blur-sm shadow-sm border-b border-gray-200">
      <div class="absolute inset-0 bg-gradient-to-r from-red-600/5 to-orange-600/5"></div>
      <div class="relative container mx-auto px-6 py-6">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
              Administration
            </h1>
            <p class="mt-1 text-gray-600">Gérez la plateforme Anamnesis et ses utilisateurs</p>
          </div>
          <div class="hidden md:flex items-center space-x-4">
            <div class="flex items-center space-x-2 text-sm text-gray-500">
              <div class="w-2 h-2 bg-red-400 rounded-full animate-pulse"></div>
              <span>Admin</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mx-auto px-6 py-6 pb-16">
      <!-- Section MEMoS -->
      <div class="mb-8">
        <div class="flex items-center mb-5">
          <div class="flex items-center space-x-3">
            <div class="w-7 h-7 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
              <LayoutIcon class="w-4 h-4 text-white" />
            </div>
            <h2 class="text-xl font-semibold text-gray-900">Gestion des MEMoS</h2>
          </div>
          <div class="ml-auto hidden sm:block">
            <span class="text-sm text-gray-500">Configuration et structure</span>
          </div>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          <!-- Sections MEMoS -->
          <router-link to="/admin_sections" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-blue-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50 opacity-50"></div>
              <div class="relative p-5 flex items-center justify-between h-full">
                <div class="flex items-center space-x-4">
                  <div class="w-10 h-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <LayoutIcon class="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 class="text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                      Sections MEMoS
                    </h3>
                    <p class="text-sm text-gray-500">Structure des formulaires</p>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
          
          <!-- Schémas MEMoS -->
          <router-link to="/admin_schemas" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-purple-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-purple-50 to-violet-50 opacity-50"></div>
              <div class="relative p-5 flex items-center justify-between h-full">
                <div class="flex items-center space-x-4">
                  <div class="w-10 h-10 bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Share2Icon class="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 class="text-base font-semibold text-gray-900 group-hover:text-purple-600 transition-colors">
                      Schémas MEMoS
                    </h3>
                    <p class="text-sm text-gray-500">Modèles de données</p>
                  </div>
                </div>
              </div>
            </div>
          </router-link>

          <!-- Mappings d'Export -->
          <router-link to="/admin/export-mappings" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-cyan-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-cyan-50 to-sky-50 opacity-50"></div>
              <div class="relative p-5 flex items-center justify-between h-full">
                <div class="flex items-center space-x-4">
                  <div class="w-10 h-10 bg-gradient-to-r from-cyan-500 to-cyan-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <ArrowRightLeftIcon class="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 class="text-base font-semibold text-gray-900 group-hover:text-cyan-600 transition-colors">
                      Mappings d'Export
                    </h3>
                    <p class="text-sm text-gray-500">Exports configurables</p>
                  </div>
                </div>
              </div>
            </div>
          </router-link>

          <!-- Traductions Métamodèle -->
          <router-link to="/admin/metamodel-translations" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-emerald-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-emerald-50 to-green-50 opacity-50"></div>
              <div class="relative p-5 flex items-center justify-between h-full">
                <div class="flex items-center space-x-4">
                  <div class="w-10 h-10 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <LanguagesIcon class="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 class="text-base font-semibold text-gray-900 group-hover:text-emerald-600 transition-colors">
                      Traductions
                    </h3>
                    <p class="text-sm text-gray-500">Libellés des champs</p>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      
      <!-- Section Utilisateurs (Superadmin uniquement) -->
      <div v-if="isSuperAdmin" class="mb-8">
        <div class="flex items-center mb-5">
          <div class="flex items-center space-x-3">
            <div class="w-7 h-7 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center">
              <UsersIcon class="w-4 h-4 text-white" />
            </div>
            <h2 class="text-xl font-semibold text-gray-900">Gestion des Utilisateurs</h2>
          </div>
          <div class="ml-auto hidden sm:block">
            <span class="text-sm text-gray-500">Comptes et permissions</span>
          </div>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
          <!-- Utilisateurs (Superadmin uniquement) -->
          <router-link to="/admin_users" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-yellow-300 h-28">
              <div class="absolute inset-0 bg-gradient-to-br from-yellow-50 to-amber-50 opacity-50"></div>
              <div class="relative p-5 flex items-center justify-between h-full">
                <div class="flex items-center space-x-4">
                  <div class="w-10 h-10 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <UsersIcon class="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 class="text-base font-semibold text-gray-900 group-hover:text-yellow-600 transition-colors">
                      Utilisateurs
                    </h3>
                    <p class="text-sm text-gray-500">Gestion des comptes et rôles</p>
                    <p class="text-xs text-gray-400 mt-1">Permissions et accès</p>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- Section Assets -->
      <div class="mb-8">
        <div class="flex items-center mb-5">
          <div class="flex items-center space-x-3">
            <div class="w-7 h-7 bg-gradient-to-r from-green-500 to-green-600 rounded-lg flex items-center justify-center">
              <DatabaseIcon class="w-4 h-4 text-white" />
            </div>
            <h2 class="text-xl font-semibold text-gray-900">Gestion des Assets</h2>
          </div>
          <div class="ml-auto hidden sm:block">
            <span class="text-sm text-gray-500">Données patrimoniales</span>
          </div>
        </div>
        
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          <!-- Agents -->
          <router-link to="/admin_agents" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-red-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-red-50 to-rose-50 opacity-50"></div>
              <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                <div class="w-10 h-10 bg-gradient-to-r from-red-500 to-red-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                  <PersonStandingIcon class="w-5 h-5 text-white" />
                </div>
                <h3 class="text-sm font-semibold text-gray-900 group-hover:text-red-600 transition-colors">
                  Agents
                </h3>
              </div>
            </div>
          </router-link>

          <!-- Lieux -->
          <router-link to="/admin_locations" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-indigo-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-indigo-50 to-blue-50 opacity-50"></div>
              <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                <div class="w-10 h-10 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                  <MapIcon class="w-5 h-5 text-white" />
                </div>
                <h3 class="text-sm font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors">
                  Lieux
                </h3>
              </div>
            </div>
          </router-link>

          <!-- Material entities -->
          <router-link to="/admin_material_entities" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-orange-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-orange-50 to-amber-50 opacity-50"></div>
              <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                <div class="w-10 h-10 bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                  <BoxIcon class="w-5 h-5 text-white" />
                </div>
                <h3 class="text-sm font-semibold text-gray-900 group-hover:text-orange-600 transition-colors">
                  Objets
                </h3>
              </div>
            </div>
          </router-link>

          <!-- Digital entities -->
          <router-link to="/admin_digital_entities" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-teal-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-teal-50 to-cyan-50 opacity-50"></div>
              <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                <div class="w-10 h-10 bg-gradient-to-r from-teal-500 to-teal-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                  <DatabaseIcon class="w-5 h-5 text-white" />
                </div>
                <h3 class="text-sm font-semibold text-gray-900 group-hover:text-teal-600 transition-colors">
                  Datasets
                </h3>
              </div>
            </div>
          </router-link>

          <!-- Projets -->
          <router-link to="/admin_projects" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-pink-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-pink-50 to-rose-50 opacity-50"></div>
              <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                <div class="w-10 h-10 bg-gradient-to-r from-pink-500 to-pink-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                  <FolderIcon class="w-5 h-5 text-white" />
                </div>
                <h3 class="text-sm font-semibold text-gray-900 group-hover:text-pink-600 transition-colors">
                  Projets
                </h3>
              </div>
            </div>
          </router-link>

          <!-- Memos -->
          <router-link to="/admin_memos" class="group">
            <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-green-300 h-24">
              <div class="absolute inset-0 bg-gradient-to-br from-green-50 to-emerald-50 opacity-50"></div>
              <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                <div class="w-10 h-10 bg-gradient-to-r from-green-500 to-green-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                  <FileTextIcon class="w-5 h-5 text-white" />
                </div>
                <h3 class="text-sm font-semibold text-gray-900 group-hover:text-green-600 transition-colors">
                  Memos
                </h3>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- Section Outils Plateforme -->
      <div class="mb-8">
        <div class="flex items-center mb-5">
          <div class="flex items-center space-x-3">
            <div class="w-7 h-7 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-lg flex items-center justify-center">
              <SettingsIcon class="w-4 h-4 text-white" />
            </div>
            <h2 class="text-xl font-semibold text-gray-900">Outils Plateforme</h2>
          </div>
          <div class="ml-auto hidden sm:block">
            <span class="text-sm text-gray-500">Administration avancée</span>
          </div>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <!-- Sauvegarde -->
          <div class="relative group" @mouseenter="showTooltip.backup = true" @mouseleave="showTooltip.backup = false">
            <div class="cursor-pointer">
              <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-gray-400 h-24">
                <div class="absolute inset-0 bg-gradient-to-br from-gray-50 to-slate-50 opacity-50"></div>
                <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                  <div class="w-10 h-10 bg-gradient-to-r from-gray-600 to-gray-700 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                    <DownloadIcon class="w-5 h-5 text-white" />
                  </div>
                  <h3 class="text-sm font-semibold text-gray-900 group-hover:text-gray-700 transition-colors">
                    Sauvegarde
                  </h3>
                </div>
              </div>
            </div>
            <FutureFeatureTooltip 
              v-if="showTooltip.backup"
              title="Système de Sauvegarde"
              description="Fonctionnalité de sauvegarde automatique et manuelle des données de la plateforme. Permettra la création de points de restauration et l'export des données critiques."
            />
          </div>

          <!-- Logs système -->
          <div class="relative group" @mouseenter="showTooltip.logs = true" @mouseleave="showTooltip.logs = false">
            <div class="cursor-pointer">
              <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-slate-400 h-24">
                <div class="absolute inset-0 bg-gradient-to-br from-slate-50 to-gray-50 opacity-50"></div>
                <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                  <div class="w-10 h-10 bg-gradient-to-r from-slate-600 to-slate-700 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                    <FileTextIcon class="w-5 h-5 text-white" />
                  </div>
                  <h3 class="text-sm font-semibold text-gray-900 group-hover:text-slate-700 transition-colors">
                    Logs
                  </h3>
                </div>
              </div>
            </div>
            <FutureFeatureTooltip 
              v-if="showTooltip.logs"
              title="Centre de Logs"
              description="Interface de consultation des logs système en temps réel. Filtrage par niveau de gravité, recherche avancée et alertes automatiques pour le monitoring de la plateforme."
            />
          </div>

          <!-- Maintenance -->
          <div class="relative group" @mouseenter="showTooltip.maintenance = true" @mouseleave="showTooltip.maintenance = false">
            <div class="cursor-pointer">
              <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-amber-400 h-24">
                <div class="absolute inset-0 bg-gradient-to-br from-amber-50 to-yellow-50 opacity-50"></div>
                <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                  <div class="w-10 h-10 bg-gradient-to-r from-amber-500 to-amber-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                    <WrenchIcon class="w-5 h-5 text-white" />
                  </div>
                  <h3 class="text-sm font-semibold text-gray-900 group-hover:text-amber-600 transition-colors">
                    Maintenance
                  </h3>
                </div>
              </div>
            </div>
            <FutureFeatureTooltip 
              v-if="showTooltip.maintenance"
              title="Mode Maintenance"
              description="Outils de maintenance de la plateforme incluant la planification d'arrêts programmés, nettoyage de la base de données et optimisation des performances système."
            />
          </div>

          <!-- Métriques -->
          <div class="relative group" @mouseenter="showTooltip.metrics = true" @mouseleave="showTooltip.metrics = false">
            <div class="cursor-pointer">
              <div class="relative overflow-hidden bg-white/90 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-emerald-400 h-24">
                <div class="absolute inset-0 bg-gradient-to-br from-emerald-50 to-green-50 opacity-50"></div>
                <div class="relative p-4 flex flex-col items-center justify-center h-full text-center">
                  <div class="w-10 h-10 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-2">
                    <TrendingUpIcon class="w-5 h-5 text-white" />
                  </div>
                  <h3 class="text-sm font-semibold text-gray-900 group-hover:text-emerald-600 transition-colors">
                    Métriques
                  </h3>
                </div>
              </div>
            </div>
            <FutureFeatureTooltip 
              v-if="showTooltip.metrics"
              title="Tableau de Bord Métriques"
              description="Dashboard complet avec métriques en temps réel sur l'utilisation de la plateforme, performances des serveurs et statistiques d'activité des utilisateurs."
            />
          </div>
        </div>
      </div>

      <!-- Section statistiques admin -->
      <div class="bg-white/90 backdrop-blur-sm rounded-xl shadow-sm border border-gray-200 p-5">
        <h3 class="text-base font-semibold text-gray-900 mb-4">Statistiques plateforme</h3>
        <div class="grid grid-cols-3 md:grid-cols-6 gap-4">
          <div class="text-center p-3 bg-gray-50/80 rounded-lg">
            <div class="text-xl font-bold text-blue-600">-</div>
            <div class="text-xs text-gray-500">Sections</div>
          </div>
          <div class="text-center p-3 bg-gray-50/80 rounded-lg">
            <div class="text-xl font-bold text-yellow-600">-</div>
            <div class="text-xs text-gray-500">Users</div>
          </div>
          <div class="text-center p-3 bg-gray-50/80 rounded-lg">
            <div class="text-xl font-bold text-red-600">-</div>
            <div class="text-xs text-gray-500">Agents</div>
          </div>
          <div class="text-center p-3 bg-gray-50/80 rounded-lg">
            <div class="text-xl font-bold text-indigo-600">-</div>
            <div class="text-xs text-gray-500">Lieux</div>
          </div>
          <div class="text-center p-3 bg-gray-50/80 rounded-lg">
            <div class="text-xl font-bold text-pink-600">-</div>
            <div class="text-xs text-gray-500">Projets</div>
          </div>
          <div class="text-center p-3 bg-gray-50/80 rounded-lg">
            <div class="text-xl font-bold text-green-600">-</div>
            <div class="text-xs text-gray-500">Memos</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FutureFeatureTooltip from "@/components/UI/FutureFeatureTooltip.vue";
import { useAuthStore } from "@/stores/auth";
import {
    ArrowRightLeftIcon,
    BoxIcon,
    DatabaseIcon,
    DownloadIcon,
    FileTextIcon,
    FolderIcon,
    LanguagesIcon,
    LayoutIcon,
    MapIcon,
    PersonStandingIcon,
    SettingsIcon,
    Share2Icon,
    TrendingUpIcon,
    UsersIcon,
    WrenchIcon
} from "lucide-vue-next";
import { reactive } from "vue";

// Store d'authentification
const authStore = useAuthStore();
const { isSuperAdmin } = authStore;

// État réactif pour contrôler l'affichage des tooltips
const showTooltip = reactive({
  backup: false,
  logs: false,
  maintenance: false,
  metrics: false
});
</script>

<style scoped>
/* Animations personnalisées */
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.float-animation {
  animation: float 6s ease-in-out infinite;
}

/* Effet de brillance sur hover */
.group:hover .shine {
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.5) 50%,
    transparent 70%
  );
  animation: shine 0.6s ease-out;
}

@keyframes shine {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
</style> 